import styled from "styled-components";
import { media } from "../../theme/theme";
import { Body, H2 } from "../Typography";

const MOBILE_BR = 640;
const TABLET_BR = 1000;

export const Pledge2Wrapper = styled.div<{ useBkg?: boolean }>`
    width: 100%;
    background: ${({ theme }) => theme.marketing.colors.blackPearl30};
    padding: 180px 0 0px;
    position: relative;

    ${media.phone} {
        padding: 300px 0 0px;
    }

    ${media.custom(TABLET_BR)} {
        padding: ${({ useBkg }) => useBkg ? "400px 0 25px" : "300px 0 25px"};
        padding-bottom: 0;
    }
`;

export const PledgeSVGWrapper = styled.div`
    max-width: 1230px;
    margin: 0 auto;
    width: 100%;
    position: relative;
`;

export const PledgeImageWrapper = styled.div`
    width: 100%;
    overflow: hidden;
    display: none;

    ${media.custom(TABLET_BR)} {
        display: block;
    }
`;

export const PledgeUserContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 0 15px;
    align-items: flex-end;
   
    ${media.custom(MOBILE_BR)} {
        flex-direction: row;
    }

    ${media.custom(TABLET_BR)} {
        position: absolute;
        bottom: 0;
        left: 47%;
        transform: translateX(-50%);
        align-items: flex-start;
    }

    > div {
        &:first-child {
            order: 1;
            margin: 0 auto;

            ${media.custom(MOBILE_BR)} {
                order: 0;
                margin: initial;
            }
        }

        &:nth-child(2) {
            max-width: 630px;
            padding-bottom: 20px;

            ${media.custom(TABLET_BR)} {
                min-width: 630px;
                margin-left: 25px;
            }
        }
    }
`;

export const PledgeUserImg = styled.img`
    max-width: 250px;
    height: auto;

    ${media.custom(TABLET_BR)} {
        max-width: 332px;
    }
`;

export const PledgeTitle = styled(H2)`
    color:  ${({ theme }) => theme ? theme.marketing.colors.dodgerBlue100 : null};
    text-align: center;

    ${media.custom(MOBILE_BR)} {
        text-align: left;
    }
`;

export const PledgeBody = styled(Body)`
    color: ${({ theme }) => theme ? theme.marketing.colors.blackPearl80 : null};
    text-align: center;

    ${media.custom(MOBILE_BR)} {
        text-align: left;
    }
`;